import { FormSelect, FormTextBox, IDynamicFormRow } from '@src/components';
import {
    LogAccessViaType,
    LogCategoryType,
    LogStatusType,
} from '@src/services/activityLogs/activityLogTypes';
import { TFunction } from 'i18next';

type LogFilterSchemaProps = {
    t: TFunction;
};
export function logFilterSchema({
    t,
}: LogFilterSchemaProps): IDynamicFormRow[] {
    const statusOptions: { label: string; value: LogStatusType }[] = [
        { label: 'Failure', value: 'Failure' },
        { label: 'Success', value: 'Success' },
    ];

    const accessViaOptions: { label: string; value: LogAccessViaType }[] = [
        { label: 'Portal', value: 'Portal' },
        { label: 'API', value: 'API' },
        { label: 'System', value: 'System' },
    ];

    return [
        {
            label: t('forms.status'),
            keyName: 'status',
            Component: FormSelect,
            registerOptions: {
                required: false,
            },
            formProps: {
                selectOptions: statusOptions,
                placeholder: 'Select Status',
            },
        },
        {
            label: t('forms.accessVia'),
            keyName: 'accessVia',
            Component: FormSelect,
            registerOptions: {
                required: false,
            },
            formProps: {
                selectOptions: accessViaOptions,
                placeholder: 'Select Access Via',
            },
        },
    ];
}
